import { Component, Input } from '@angular/core';
import { CSSProperties } from '../../../models/styles.interfaces';
import { BaseProperties } from '../../../models/ui.interfaces';
import { VisibilityConfig } from '../label-with-icon/models/label-with-icon.interfaces';

/**
 * This component is responsible to create a text container with custom
 * styling and text direction.
 */
@Component({
  selector: 'idp-text',
  templateUrl: './text.component.html',
  styleUrls: ['./text.component.scss']
})
export class TextComponent
  implements BaseProperties<VisibilityConfig, string, CSSProperties>
{
  /** This props content text */
  @Input() content = '' as string;
  /**
   * This is the primary configuration for this component.
   * You can enable/disable this according to the use case by
   * passing visible props
   */
  @Input() config = {} as VisibilityConfig;
  /** This holds style properties. You can set apply styling according to the use case. */
  @Input() styles = {} as CSSProperties;

  constructor() {
    /** Set default properties for config, content and styles */
    this.config = {
      visible: true
    };
    this.styles = {
      position: 'left'
    };
  }

  /** prepare text container class according to the position */
  get textContainerClass(): string {
    return this.styles.position
      ? 'text-align-' + this.styles.position
      : 'text-align-left';
  }
}
